import React, { useState, useEffect } from 'react';
import BeefBracketTallyVoteLoader from './BeefBracketTallyVoteLoader';

export default function BeefBracketVoteTallyVoteCount({
  view,
  scoreObject,
  setScoreObject,
  isLoading,
  winningContender,
  useSmallFont
}) {
  const [voteCount, setVoteCount] = useState(scoreObject.voteCount || 0);
  useEffect(() => {
    setVoteCount(scoreObject.voteCount || 0);
  }, [scoreObject]);

  // Make sure voteCount always have three digits, padding with zeros if necessary
  const paddedVoteCount = voteCount.toString().padStart(3, '0');

  return (
    <div className={`beef-bracket-vote-tally-vote-count ${view}`}>
      {isLoading ? (
        <BeefBracketTallyVoteLoader
          winningContender={winningContender === scoreObject.title}
          digitCount={paddedVoteCount.length}
        />
      ) : (
        <div
          className={`vote-count ${
            useSmallFont ? 'small--font' : ''
          } ${winningContender === scoreObject.title ? 'winning' : ''}`}
        >
          {paddedVoteCount.split('').map((digit, index) => (
            <div className="vote-count-digit" key={index}>
              <span key={index} className={`digit digit-${digit}`}>
                {digit}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
